module Meevo.Plugins.AppointmentBook {
    class ResourceCountFiltersController {
        static $inject = ['Meevo.Plugins.AppointmentBook.Services.AppointmentBookFilterActionsService',
            "appointmentBookModalService",
            "resourceCat"];

        constructor(private filterActions, public modal, public resourceCat) {
            
        }

        clear() {
            this.resourceCat = undefined;
            this.filterActions.updateResourceCountFilters(this.resourceCat);
        }

        save() {
            this.filterActions.updateResourceCountFilters(this.resourceCat);
            this.modal.hideModal();
        }
     }
    angular.module("ApptBookApp")
        .controller("meevo.plugins.appointmentBook.ResourceCountFiltersController", ResourceCountFiltersController);
}